module.exports = ":host button {\n  margin-right: 1rem; }\n"